
import { Vue } from 'vue-class-component'

export default class ObjectContacts extends Vue {
    headline = "Kontakte"
}
